(function () {
  if (window.__p2rInit) return; window.__p2rInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.p2r-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function hero(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-p2r-hero]').forEach(function (h) {
      if (h.__p2r) return; h.__p2r = true;
      var media = h.querySelector('.p2r-hero__media'), content = h.querySelector('.p2r-hero__content'), ring = h.querySelector('.p2r-hero__ring');
      var mx = 0, my = 0, sy = 0, raf = null;
      function draw() {
        raf = null;
        if (media) media.style.transform = 'translate3d(' + (mx * -14) + 'px,' + (sy * 0.25 + my * -10) + 'px,0) scale(1.04)';
        if (content) content.style.transform = 'translate3d(0,' + (sy * -0.12) + 'px,0)';
        if (ring) ring.style.transform = 'translateY(-50%) rotateX(' + (64 - my * 8) + 'deg) rotateY(' + (mx * 10) + 'deg)';
      }
      function q() { if (!raf) raf = requestAnimationFrame(draw); }
      h.addEventListener('pointermove', function (e) { var r = h.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5; q(); });
      window.addEventListener('scroll', function () { var r = h.getBoundingClientRect(); if (r.bottom > 0) { sy = Math.max(0, -r.top); q(); } }, { passive: true });
    });
  }

  function reviews(root) {
    (root || document).querySelectorAll('[data-p2r-reviews]').forEach(function (s) {
      var t = s.querySelector('.p2r-reviews__track'); if (!t) return;
      s.querySelectorAll('[data-dir]').forEach(function (b) {
        b.onclick = function () { t.scrollBy({ left: (+b.dataset.dir) * t.clientWidth * 0.8, behavior: 'smooth' }); };
      });
    });
  }

  function addBusinessDays(d, n) { var x = new Date(d); var c = 0; while (c < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) c++; } return x; }
  function delivery(root) {
    (root || document).querySelectorAll('[data-p2r-delivery]').forEach(function (el) {
      var out = el.querySelector('[data-out]'), sel = el.querySelector('select');
      var lang = document.documentElement.lang || undefined;
      function upd() {
        var o = sel ? sel.options[sel.selectedIndex] : el;
        var min = +(o.dataset.min || el.dataset.min), max = +(o.dataset.max || el.dataset.max);
        var proc = +(el.dataset.proc || 0), now = new Date();
        var a = addBusinessDays(now, proc + min), b = addBusinessDays(now, proc + max);
        var f = { weekday: 'short', day: 'numeric', month: 'short' };
        out.textContent = a.toLocaleDateString(lang, f) + ' – ' + b.toLocaleDateString(lang, f);
      }
      if (sel) {
        var cc = (window.Shopify && Shopify.country) || '';
        for (var i = 0; i < sel.options.length; i++) { if ((sel.options[i].dataset.codes || '').split(',').indexOf(cc) > -1) { sel.selectedIndex = i; break; } }
        sel.onchange = upd;
      }
      upd();
    });
  }

  function init(root) { reveal(root); hero(root); reviews(root); delivery(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
